import {put, call, takeLatest} from 'redux-saga/effects';

import {getDashboardsConfigurationRequest, getDashboardsConfigurationSuccess, getDashboardsConfigurationFail} from './actions';
import * as api from '../../../../services/api';

function* getDashboardConfiguration() {
    try {
        const response = yield call(api.getDashboardsConfiguration);
        if (response && response.data) {
            yield put(getDashboardsConfigurationSuccess({configuration: response.data}));
        } else {
            yield put(getDashboardsConfigurationFail());
        }
    } catch (err) {
        yield put(getDashboardsConfigurationFail());
    }
}

function* dashboardConfiguration() {
    yield takeLatest(getDashboardsConfigurationRequest.type, getDashboardConfiguration);
}

export default dashboardConfiguration;
